import { createRouter, createWebHistory } from 'vue-router'
import LogoPage from '../components/LogoPage.vue'
import IntroPage from '../components/IntroPage.vue'
import MainPage from '../components/MainPage.vue'
import ResultDisplay from '../components/ResultDisplay.vue'

const routes = [
  {
    path: '/',
    name: 'Logo',
    component: LogoPage
  },
  {
    path: '/intro',
    name: 'Intro',
    component: IntroPage
  },
  {
    path: '/form',
    name: 'Form',
    component: MainPage
  },
  {
    path: '/result',
    name: 'Result',
    component: ResultDisplay,
    props: (route) => ({
      formData: route.query.formData ? JSON.parse(decodeURIComponent(route.query.formData)) : null,
      fortuneData: route.query.fortuneData ? JSON.parse(decodeURIComponent(route.query.fortuneData)) : null
    })
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 重定向到首页
router.beforeEach((to, from, next) => {
  // 如果访问根路径，直接跳转到logo页面
  if (to.path === '/') {
    next()
  } else {
    next()
  }
})

export default router